import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class StatsResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/stats' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
